import { sortItems } from "./sortItems.js";
import { toTruthy } from "./toTruthy.js";

export function sortTruthy<T>(items: T[]): NonNullable<T>[] {
  return sortItems<NonNullable<T>>(toTruthy(items));
}
